module.exports = __webpack_public_path__ + "img/table.8b1e7f5c.jpg";